
import {of as observableOf,  Observable ,  BehaviorSubject } from 'rxjs';

import {tap, delay} from 'rxjs/operators';
import { Injectable } from "@angular/core";
// import { LoginResponse } from "../model";
import "rxjs/add/observable/of";
import "rxjs/add/operator/do";
import "rxjs/add/operator/delay";
import { LocalStorageService } from "../services/local-storage.service";
import { storeKeys } from "../config";

@Injectable()
export class AuthService {
	public allow: any = false;
	isLoggedIn: boolean;
	userDetail: any;
	token: string;
	redirectMenu: string;
	menusLoadingSubject: BehaviorSubject<boolean> = new BehaviorSubject(false);
	allSystemFlagsCity:any =null;
	allSystemFlagsRole:any = null;
	allSystemFlagsAgency:any = null;
	allSystemFlagsCityName: any = null;
	allSystemFlagsGpsAgency: any = null;
	allSystemFlagsGpsAgencyName: any = null;
	public loaderStart = new BehaviorSubject<boolean>(false);
	public flagTriggerCity = new BehaviorSubject<boolean>(false)
	public flagTriggerRole = new BehaviorSubject<boolean>(false)
    public flagTriggerAgency = new BehaviorSubject<boolean>(false)
	public flagTriggerCityName = new BehaviorSubject<boolean>(false)
	public flagTriggerGpsAgency = new BehaviorSubject<boolean>(false)
	public flagTriggerGpsAgencyName = new BehaviorSubject<boolean>(false)

	constructor(private storage: LocalStorageService) {

		this.isLoggedIn = this.getValueForKey(storeKeys.isLoggedIn);
		this.token = this.getValueForKey(storeKeys.Authorization);
		this.redirectMenu = this.getValueForKey(storeKeys.redirectMenu);
		if (!this.userDetail) this.userDetail = this.getValueForKey(storeKeys.userDetail);
	}

	saveValue(key: string, value: any) {
		this.storage.setItem(key, value);
	}

	getValueForKey(key) {
		return this.storage.getItem(key);
	}
	getGpsAgencyId(){
		return this.storage.getItem('gpsAgencyId');	
	}
	getGpsAgencyName(){
		return this.storage.getItem('gpsAgencyName');
	}
	getCityId(){
		return this.storage.getItem('cityId');
	}
	getCityName(){
		return this.storage.getItem('cityName');
	}
	getCities(){
		return this.storage.getItem('cities');
	}

	updateLogin(f: boolean, userDetail,token?): Observable<boolean> {
		return observableOf(true).pipe(delay(3),tap(() => {
			this.isLoggedIn = f;
			this.userDetail = userDetail;
			if (token) {
				this.saveValue(storeKeys.Authorization, token.access_token)
				this.saveValue('refresh_token',  token.refresh_token);
			  }
			if (this.isLoggedIn) {
				this.token = this.getValueForKey(storeKeys.Authorization);
			} else {
				this.token = null;
				this.saveValue(storeKeys.Authorization, this.token);

			}
			this.saveValue(storeKeys.isLoggedIn, f);

			this.saveValue(storeKeys.userDetail, this.userDetail);
		}),);
	}

	hasValidAgency() {
		if (this.userDetail)
			return !(this.userDetail.flag == 0 || !this.userDetail.agencyId);
		else return false;
	}

	hasAgencyId() {
		if(this.userDetail){
			return this.userDetail.agencyId;
		}
		else return false;
	}
	isRegionOwner() {
		if (this.userDetail)
			return (this.userDetail?.regionalRole ??false);
		else return false;
	}

	isValidRole() {
		if (this.userDetail)
			return (this.userDetail.rolename == 'City Owner' || this.userDetail.rolename == 'Admin' || this.userDetail.rolename =='SuperAdmin');
		else return false;
	}

	isCityOwnerSuperAdmin() {
		if(this.userDetail){
			return (this.userDetail.rolename == 'City Owner' || this.userDetail.rolename == 'SuperAdmin');

		}
		else return false;
	}

	hasAllAccess() {
		if (this.userDetail)
			return (this.userDetail.rolename == 'Admin'  || this.userDetail.rolename =='SuperAdmin');
		else return false;
	}
	isSuper() {
		if (this.userDetail)
			return (this.userDetail.rolename =='SuperAdmin');
		else return false;
	}
	isCityOwner() {
		if (this.userDetail)
			return (this.userDetail.rolename == 'City Owner');
		else return false;
	}
	isAdmin(){
		if(this.userDetail)
			return (this.userDetail.rolename == 'Admin');
		else return false;
	}
	hasValidCity() {
		if (this.userDetail)
			return !(this.userDetail.flag == 0 || !this.userDetail.cityId);
		else return false;
	}
	isSuperCity(){
		if(this.userDetail)
			return (this.userDetail.cityName =="SuperCity");
		else return false;
	}

	hasValidDepot() {
		if (this.userDetail) {
			return !(this.userDetail.flag == 0 || !this.userDetail.depotId);
		} else return false;
	}
	hasRoleCheck(){
		if (this.userDetail)
		return !(this.userDetail.rolename == 'Cashier'  || this.userDetail.rolename =='ETIM Operator');
	else return true;
	}
	hasCashier(){
		if (this.userDetail)
		return (this.userDetail.rolename == 'Cashier'  || this.userDetail.rolename =='ETIM Operator');
	else return false;
	}
	hasBusConfigAllow(){
		if (this.userDetail)
		return (this.userDetail.rolename == 'City Owner'  || this.userDetail.rolename =='Operations Manager');
	else return false;
	}



}

